module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 7);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(8)

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(6),
  /* template */
  __webpack_require__(11),
  /* scopeId */
  "data-v-6317c8fc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 3 */
/***/ (function(module, exports) {

/*
 * classList.js: Cross-browser full element.classList implementation.
 * 1.1.20170427
 *
 * By Eli Grey, http://eligrey.com
 * License: Dedicated to the public domain.
 *   See https://github.com/eligrey/classList.js/blob/master/LICENSE.md
 */

/*global self, document, DOMException */

/*! @source http://purl.eligrey.com/github/classList.js/blob/master/classList.js */

if ("document" in window.self) {

// Full polyfill for browsers with no classList support
// Including IE < Edge missing SVGElement.classList
if (!("classList" in document.createElement("_")) 
	|| document.createElementNS && !("classList" in document.createElementNS("http://www.w3.org/2000/svg","g"))) {

(function (view) {

"use strict";

if (!('Element' in view)) return;

var
	  classListProp = "classList"
	, protoProp = "prototype"
	, elemCtrProto = view.Element[protoProp]
	, objCtr = Object
	, strTrim = String[protoProp].trim || function () {
		return this.replace(/^\s+|\s+$/g, "");
	}
	, arrIndexOf = Array[protoProp].indexOf || function (item) {
		var
			  i = 0
			, len = this.length
		;
		for (; i < len; i++) {
			if (i in this && this[i] === item) {
				return i;
			}
		}
		return -1;
	}
	// Vendors: please allow content code to instantiate DOMExceptions
	, DOMEx = function (type, message) {
		this.name = type;
		this.code = DOMException[type];
		this.message = message;
	}
	, checkTokenAndGetIndex = function (classList, token) {
		if (token === "") {
			throw new DOMEx(
				  "SYNTAX_ERR"
				, "An invalid or illegal string was specified"
			);
		}
		if (/\s/.test(token)) {
			throw new DOMEx(
				  "INVALID_CHARACTER_ERR"
				, "String contains an invalid character"
			);
		}
		return arrIndexOf.call(classList, token);
	}
	, ClassList = function (elem) {
		var
			  trimmedClasses = strTrim.call(elem.getAttribute("class") || "")
			, classes = trimmedClasses ? trimmedClasses.split(/\s+/) : []
			, i = 0
			, len = classes.length
		;
		for (; i < len; i++) {
			this.push(classes[i]);
		}
		this._updateClassName = function () {
			elem.setAttribute("class", this.toString());
		};
	}
	, classListProto = ClassList[protoProp] = []
	, classListGetter = function () {
		return new ClassList(this);
	}
;
// Most DOMException implementations don't allow calling DOMException's toString()
// on non-DOMExceptions. Error's toString() is sufficient here.
DOMEx[protoProp] = Error[protoProp];
classListProto.item = function (i) {
	return this[i] || null;
};
classListProto.contains = function (token) {
	token += "";
	return checkTokenAndGetIndex(this, token) !== -1;
};
classListProto.add = function () {
	var
		  tokens = arguments
		, i = 0
		, l = tokens.length
		, token
		, updated = false
	;
	do {
		token = tokens[i] + "";
		if (checkTokenAndGetIndex(this, token) === -1) {
			this.push(token);
			updated = true;
		}
	}
	while (++i < l);

	if (updated) {
		this._updateClassName();
	}
};
classListProto.remove = function () {
	var
		  tokens = arguments
		, i = 0
		, l = tokens.length
		, token
		, updated = false
		, index
	;
	do {
		token = tokens[i] + "";
		index = checkTokenAndGetIndex(this, token);
		while (index !== -1) {
			this.splice(index, 1);
			updated = true;
			index = checkTokenAndGetIndex(this, token);
		}
	}
	while (++i < l);

	if (updated) {
		this._updateClassName();
	}
};
classListProto.toggle = function (token, force) {
	token += "";

	var
		  result = this.contains(token)
		, method = result ?
			force !== true && "remove"
		:
			force !== false && "add"
	;

	if (method) {
		this[method](token);
	}

	if (force === true || force === false) {
		return force;
	} else {
		return !result;
	}
};
classListProto.toString = function () {
	return this.join(" ");
};

if (objCtr.defineProperty) {
	var classListPropDesc = {
		  get: classListGetter
		, enumerable: true
		, configurable: true
	};
	try {
		objCtr.defineProperty(elemCtrProto, classListProp, classListPropDesc);
	} catch (ex) { // IE 8 doesn't support enumerable:true
		// adding undefined to fight this issue https://github.com/eligrey/classList.js/issues/36
		// modernie IE8-MSW7 machine has IE8 8.0.6001.18702 and is affected
		if (ex.number === undefined || ex.number === -0x7FF5EC54) {
			classListPropDesc.enumerable = false;
			objCtr.defineProperty(elemCtrProto, classListProp, classListPropDesc);
		}
	}
} else if (objCtr[protoProp].__defineGetter__) {
	elemCtrProto.__defineGetter__(classListProp, classListGetter);
}

}(window.self));

}

// There is full or partial native classList support, so just check if we need
// to normalize the add/remove and toggle APIs.

(function () {
	"use strict";

	var testElement = document.createElement("_");

	testElement.classList.add("c1", "c2");

	// Polyfill for IE 10/11 and Firefox <26, where classList.add and
	// classList.remove exist but support only one argument at a time.
	if (!testElement.classList.contains("c2")) {
		var createMethod = function(method) {
			var original = DOMTokenList.prototype[method];

			DOMTokenList.prototype[method] = function(token) {
				var i, len = arguments.length;

				for (i = 0; i < len; i++) {
					token = arguments[i];
					original.call(this, token);
				}
			};
		};
		createMethod('add');
		createMethod('remove');
	}

	testElement.classList.toggle("c3", false);

	// Polyfill for IE 10 and Firefox <24, where classList.toggle does not
	// support the second argument.
	if (testElement.classList.contains("c3")) {
		var _toggle = DOMTokenList.prototype.toggle;

		DOMTokenList.prototype.toggle = function(token, force) {
			if (1 in arguments && !this.contains(token) === !force) {
				return force;
			} else {
				return _toggle.call(this, token);
			}
		};

	}

	testElement = null;
}());

}


/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = require("vue");

/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = require("wc-swiper");

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

function toArray(like) {
	return Array.prototype.slice.call(like);
}
var userAgent = navigator.userAgent;
/* 移动端绑定 click 事件, pc 端绑定 dblclick 双击事件 */
function isMobile() {
	return !!userAgent.match(/AppleWebKit.*Mobile/i) || !!userAgent.match(/MIDP|SymbianOS|NOKIA|SAMSUNG|LG|NEC|TCL|Alcatel|BIRD|DBTEL|Dopod|PHILIPS|HAIER|LENOVO|MOT-|Nokia|SonyEricsson|SIE-|Amoi|ZTE/); //是否为移动终端
}
/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'App',
	data: function data() {
		return {
			show: false,
			docHeight: '',
			docWidth: '',
			current: null,
			curSlide: 0,
			/* 保存img 原本的属性 */
			property: {},
			/* 保存img浏览状态下的一些值 */
			endStatus: {},
			mask: null,
			list: [],
			children: [],
			isNotImg: false,
			showCloseBtn: true
		};
	},
	mounted: function mounted() {
		this.getDocSize();
	},

	methods: {
		/* 阻止图片浏览器出来之后, 页面内容可以滚动 */
		fx: function fx() {},

		/* 获取当前屏幕的高度和宽度, 后面计算 scale 需要用到 */
		getDocSize: function getDocSize() {
			this.docHeight = window.innerHeight;
			this.docWidth = window.innerWidth;
		},

		/* 
  	这玩意是给用户调用的, 主要就是做一个 swiper 初始化操作 
  	其实这个 index 可以通过 e 计算出来, 现在我不想计算;
  */
		/* 这玩意加参数, 记得把 index.js 里面的函数一起加上*/
		open: function open(e, list, index, key, options) {
			var _this = this;

			/* 这段主要是防止上一个还没消失, 这一个又开始点击*/
			if (document.querySelector('.wc-mask')) {
				return;
			}

			/* 初始化一下 curSlide */
			this.curSlide = index;
			/* 如果有 key 值, 说明用户传递进来的是一个对象数组, 要取其中的图片字段 */
			if (key) {
				this.list = list.map(function (item) {
					return item[key];
				});
			} else {
				this.list = list;
			}

			/* 应用用户配置 */
			if (options && typeof options.showCloseBtn !== 'undefined') {
				this.showCloseBtn = options.showCloseBtn;
			}

			/* 渲染 mask */
			this.show = true;
			/*
   	做一个延迟, 主要是因为 this.show = true 之后, 还需要一段渲染时间才能
   	真正将 mask 渲染到页面上面, 这里延迟主要就是等渲染;
   */
			setTimeout(function () {
				_this.showMask();
				/* 让图片先不显示 */
			}, 20);
			/* 
   	如果是图片, 则有一个图片放大的效果
   	如果不是图片, 则只有一个 swiper 显示出来的效果
   */
			if (e.target.tagName === 'IMG') {
				setTimeout(function () {
					document.querySelector('.wc-swiper').style.opacity = 0;
				}, 20);

				/* 根据是否是 img 来设置后续的 transition 行为 */
				this.isNotImg = false;
				/* 拿到当前的图片, 实际上下面的列表每次点击都会重新拿一遍, 这个是必然的 */
				this.current = e.target;
				var parent = e.target.parentElement;
				var children = parent.children;
				this.children = toArray(children);
				/* 获取图片的属性和终点状态 */
				this.property = this.getProperty(this.current);
				this.endStatus = this.calEndStatus(this.current);
				/* 设置图片的属性, 以及执行 transition 效果 */
				this.setProperty(this.current);
				this.transform(this.current, this.endStatus);
				/* 并且在 img 放大结束之后, 需要显示 swiper */
				var transitionend = function transitionend() {
					document.querySelector('.wc-swiper').style.opacity = 1;
					_this.recover(_this.current);
					_this.current.removeEventListener('transitionend', transitionend, false);
					/* 首先还是要把图片的 z-index 降低, 要不然显示不出来其他的元素 */
					/* 然后要展示 swiper*/
				};
				this.current.addEventListener('transitionend', transitionend, false);
			} else {
				this.isNotImg = true;
			}
		},

		/* 显示黑色的背景层 */
		showMask: function showMask() {
			var _this2 = this;

			/* 因为渲染的问题, 所以最好在 onload 结束, 其实就是异步*/
			this.mask = document.querySelector('.wc-mask');
			this.mask.classList.add('wc-mask-show');
			/* 这里的 延迟是为了触发 transition */
			setTimeout(function () {
				_this2.mask.classList.add('wc-mask-diff');

				if (isMobile()) {
					_this2.mask.addEventListener('click', _this2.maskClick, false);
				} else {
					_this2.mask.addEventListener('dblclick', _this2.maskClick, false);
				}
			}, 50);
		},

		/* 点击 mask 就隐藏*/
		maskClick: function maskClick() {
			var _this3 = this;

			/* 隐藏 swiper */
			/* 隐藏 box */
			this.mask.classList.remove('wc-mask-diff');
			var maskHide = function maskHide() {
				_this3.mask.classList.remove('wc-mask-show');
				_this3.show = false;
				_this3.mask.removeEventListener('transitionend', maskHide, false);
			};
			this.mask.addEventListener('transitionend', maskHide, false);
			if (!this.isNotImg) {
				/* 先把 swiper 的透明度给干掉 */
				document.querySelector('.wc-swiper').style.opacity = 0;
				/* 恢复图片 */
				this.setProperty(this.current);
				this.current.style.transform = 'scale(1)';
				/* 在图片恢复之后*/
				var imgHide = function imgHide() {
					/*恢复图片的样式 */
					_this3.recover(_this3.current, _this3.property);
					/* 解绑 transitionend 事件*/
					_this3.current.removeEventListener('transitionend', imgHide, false);
					/* 隐藏掉 mask*/
				};
				this.current.addEventListener('transitionend', imgHide, false);
			}
		},

		/* 滑动图片浏览器的时候 */
		transitionend: function transitionend(index) {
			/* 滑动之后要重置分页 */
			this.curSlide = index;
			/* 重置分页
   	再点击的时候, 恢复的实际上是之前的那个元素, 所以我们要让之前的那个元素已经恢复了
   */
			if (!this.isNotImg) {
				/* 先恢复之前的那个元素*/
				this.recover(this.current);
				this.current.style.transform = 'scale(1)';
				this.current = this.children[index];
				/* 要放大, 但是不能让我们看见*/
				this.endStatus = this.calEndStatus(this.current);
				/* 然后放大img*/
				this.transform(this.current, this.endStatus);
			}
		},
		transform: function transform(el, _ref) {
			var xRadio = _ref.xRadio,
			    yRadio = _ref.yRadio,
			    xTranslate = _ref.xTranslate,
			    yTranslate = _ref.yTranslate;

			el.style.transform = 'translate3d(' + xTranslate + 'px, ' + yTranslate + 'px, 0px) scale(' + xRadio + ', ' + yRadio + ')';
		},
		getProperty: function getProperty(img) {
			var m = getComputedStyle(img);
			return {
				position: m.position,
				zIndex: m.zIndex
			};
		},
		calEndStatus: function calEndStatus(img) {
			/* 首先计算出缩放的比例 */
			/*
   	先确定图片在 img-browser 里面显示的宽度; 
   	如果图片的真实宽度, 小于屏幕的宽度, 则不再缩放, 按照真实的宽度进行显示
   	如果图片的真实宽度大于屏幕的宽度, 图片的宽度需要是屏幕的宽度; 
   		如果图片宽度为屏幕宽度
   		查看当前的显示的宽度, 然后计算出 x 方向的缩放比例
   		图片的真实宽度, 到图片显示的宽度的比例, 再将这个比例和图片的真实高度比较
   		就能拿到图片在 img-browser 中显示的高度. 
   */
			var index = img.index;
			var xRadio = 0;
			var yRadio = 0;
			/* 这个值在后面还要用 */
			var height = 0;
			var xTranslate = 0;
			var yTranslate = 0;
			xRadio = parseFloat(this.docWidth / img.width);
			var radio = this.docWidth / img.naturalWidth;
			height = radio * img.naturalHeight;
			yRadio = parseFloat(height / img.height);
			/*
   	先算一下如果元素距离顶部的距离为 0 的时候, 垂直居中, y 需要偏移多少; 
   	再拿到当前元素实际距离顶部的距离
   	如果实际距离, 大于需要的距离. 
   */
			var offset = (this.docHeight - height) / 2;
			var top = img.getBoundingClientRect().top;
			/* x 轴位移 */
			xTranslate = -img.getBoundingClientRect().left;
			/*
   	这样计算是错误的.
   	if (top < offset) {
   	} else {
   		yTranslate = top - offset;
   	}						
   */
			yTranslate = parseFloat(offset - top);
			return {
				xRadio: xRadio,
				yRadio: yRadio,
				xTranslate: xTranslate,
				yTranslate: yTranslate
			};
		},
		setProperty: function setProperty(img) {
			if (img) {
				img.style.zIndex = 2002;
				img.style.position = 'relative';
			}
		},
		recover: function recover(img) {
			/* 因为有时候有些图片没加载出来, 会报错 */
			if (img) {
				img.style.zIndex = this.property.zIndex;
				img.style.position = this.property.position;
			}
		}
	}
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wcView__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wcView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__wcView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_wc_swiper__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_wc_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_wc_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_wc_swiper_style_css__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_wc_swiper_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_wc_swiper_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classlist_polyfill__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classlist_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classlist_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style_css__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__style_css__);





__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_wc_swiper___default.a);

/* 因为我用了 classlist */




var ViewConstructor = __WEBPACK_IMPORTED_MODULE_0_vue___default.a.extend(__WEBPACK_IMPORTED_MODULE_1__wcView___default.a);

var instance = null;

var initInstance = function initInstance() {
	instance = new ViewConstructor({
		el: document.createElement('div')
	});
	document.body.appendChild(instance.$el);
};

var preview = function preview(e, list, index, key, options) {
	initInstance();
	instance.open(e, list, index, key, options);
};

/* harmony default export */ __webpack_exports__["default"] = ({
	install: function install(Vue) {
		Vue.prototype.$preview = preview;
	}
});

/***/ }),
/* 8 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 9 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyB0PSIxNTEzNjYzNTM0NTAyIiBjbGFzcz0iaWNvbiIgc3R5bGU9IiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHAtaWQ9IjI1MTEiIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTI4IiBoZWlnaHQ9IjEyOCI+PGRlZnM+PHN0eWxlIHR5cGU9InRleHQvY3NzIj48L3N0eWxlPjwvZGVmcz48cGF0aCBmaWxsPSJ3aGl0ZSIgZD0iTTg5MS4yNjQgOTAxLjI0OGEzMC43ODQgMzAuNzg0IDAgMCAxLTIxLjc2LTkuMDI0TDEyOC4yNTYgMTUwLjk3NmEzMC43MiAzMC43MiAwIDEgMSA0My41Mi00My41Mmw3NDEuMzEyIDc0MS4zMTJhMzAuODQ4IDMwLjg0OCAwIDAgMS0yMS44MjQgNTIuNDgiIHAtaWQ9IjI1MTIiPjwvcGF0aD48cGF0aCBmaWxsPSJ3aGl0ZSIgZD0iTTE1MC4wMTYgOTAxLjI0OGEzMC43MiAzMC43MiAwIDAgMS0yMS43Ni01Mi41NDRsNzQxLjMxMi03NDEuMjQ4YTMwLjc4NCAzMC43ODQgMCAwIDEgNDMuNDU2IDQzLjUyTDE3MS43NzYgODkyLjIyNGEzMC43MiAzMC43MiAwIDAgMS0yMS43NiA5LjAyNCIgcC1pZD0iMjUxMyI+PC9wYXRoPjwvc3ZnPg=="

/***/ }),
/* 10 */
/***/ (function(module, exports) {

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  scopeId,
  cssModules
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  // inject cssModules
  if (cssModules) {
    var computed = Object.create(options.computed || null)
    Object.keys(cssModules).forEach(function (key) {
      var module = cssModules[key]
      computed[key] = function () { return module }
    })
    options.computed = computed
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('div', {
    staticClass: "wc-mask",
    on: {
      "touchmove": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.fx($event)
      }
    }
  }, [_c('div', {
    staticClass: "pagination"
  }, [_vm._v(_vm._s(_vm.curSlide + 1) + "/" + _vm._s(_vm.list.length))]), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showCloseBtn),
      expression: "showCloseBtn"
    }],
    staticClass: "wc-view__close-btn",
    attrs: {
      "src": __webpack_require__(9),
      "alt": ""
    },
    on: {
      "click": _vm.maskClick
    }
  }), _vm._v(" "), _c('wc-swiper', {
    staticClass: "wc-swiper",
    attrs: {
      "autoplay": false,
      "defaultSlide": _vm.curSlide,
      "pagination": false
    },
    on: {
      "transitionend": _vm.transitionend
    }
  }, _vm._l((_vm.list), function(value, key) {
    return _c('wc-slide', {
      key: key,
      staticClass: "wc-slide"
    }, [_c('img', {
      attrs: {
        "src": value,
        "alt": "",
        "width": "100%"
      }
    })])
  }))], 1) : _vm._e()
},staticRenderFns: []}

/***/ })
/******/ ]);